module.exports = __webpack_public_path__ + "img/CreditStatement.d970cf45.svg";